module.exports = __webpack_public_path__ + "static/media/RoundedRect_Tertiary@3x.ca3ade05.png";